export default {
  props: {
    title: {
      type: Object,
    },

    items: {
      type: Array,
    },

    body: {
      type: String,
    },

    direction: {
      type: String,
      default: 'center',
    },
  },
}
